module.exports = __webpack_public_path__ + "img/1.83118dd9.png";